import React, { useState } from 'react';
import { postTable } from '../../api/api';
import { showToast } from '../common/Toast';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    try {
      await postTable('tables/newsletter_subscribers', { email });
      showToast('Merci ! Vous êtes inscrit à la newsletter.');
      setEmail('');
    } catch (err) {
      showToast('Une erreur est survenue.', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="section-sm bg-alt">
      <div className="container text-center" style={{ maxWidth: '600px' }}>
        <h3 style={{ marginBottom: '8px' }}>Restez informé de nos publications</h3>
        <p className="section-lead" style={{ margin: '0 auto 24px' }}>
          Recevez nos dernières analyses et rapports directement dans votre boîte mail.
        </p>

        <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <input
            type="email"
            required
            placeholder="Votre adresse email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ flex: 1, minWidth: '240px', padding: '13px 16px', borderRadius: '999px', border: '1px solid #e1e5eb' }}
          />
          <button className="btn btn-dark" type="submit" disabled={loading}>
            {loading ? '...' : "S'abonner"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Newsletter;